import type { LocalizedText } from '@/entities/moderation';

export type LocaleKey = 'ru' | 'en' | 'uz';

export const LOCALE_ORDER: readonly {
  key: LocaleKey;
  labelKey: string;
  fallback: string;
}[] = [
  { key: 'ru', labelKey: 'detail.localeRu', fallback: 'Русский' },
  { key: 'en', labelKey: 'detail.localeEn', fallback: 'Английский' },
  { key: 'uz', labelKey: 'detail.localeUz', fallback: 'Узбекский' },
];

export function localeLine(value: LocalizedText | undefined, key: LocaleKey): string {
  return value?.[key]?.trim() ?? '';
}
